import React from 'react';
import {Table, Pagination} from 'semantic-ui-react';

export enum DialogType {
    new = "new",
    edit = "edit"
}

export interface IItemDialogProps<T>{
    item:       T,
    type:       DialogType,
    onClose:    (update: boolean) => void
}

export interface IItemsListState<T> {
    loading:    boolean,
    items:      Array<T>,
    page:       number,
    filter:     string,
    order:      string,
    desc:       boolean,
    dialog:     any
}

export function calcPagination<T>(state: IItemsListState<T>, colSpan: number, onPageChange: (page:number) => void) {
    const onPage = 15;
    const from =  (state.page - 1)  * onPage;
    const tmp = state.page * onPage;
    const filter = state.filter.toUpperCase();
    const items = filter ? state.items.filter(item => JSON.stringify(item).toUpperCase().indexOf(filter) !== -1) : state.items;
    if (state.order)
        items.sort((x: any, y: any) => state.desc ? y[state.order].localeCompare(x[state.order]) : x[state.order].localeCompare(y[state.order]));
    const to = tmp < items.length ? tmp : undefined;
    const pagesCount = Math.floor(items.length / onPage) + (items.length % onPage ? 1 : 0);
    const data = items.slice(from, to);

    const ctrl = items.length > onPage
        ? <Table.Footer>
            <Table.Row>
                <Table.HeaderCell colSpan={colSpan}>
                    <Pagination
                        floated='right'
                        defaultActivePage={1}
                        firstItem={null}
                        lastItem={null}
                        pointing
                        secondary
                        totalPages={pagesCount}
                        onPageChange={(event, data) => onPageChange(data.activePage as number)}
                    />
                </Table.HeaderCell>
            </Table.Row>
        </Table.Footer>
        : null;

    return {
        data,
        ctrl
    }
}